import React, { useState } from 'react';
import { CheckIcon, ChevronDownIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { volumes } from '../data/volumes';
import { accentStyles } from '../utils/accents';
export function VolumesSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section id="volumes" className="w-full scroll-mt-6 bg-sand py-10 sm:py-12" aria-labelledby="volumes-heading" data-id="element-217" data-mp="7qppw3mmitr8">
      <div className="mx-auto max-w-4xl px-6" data-id="element-218" data-mp="3g5rdjfeqsllp">
        <SectionHeading eyebrow="What’s inside" title={<span id="volumes-heading" data-id="element-220" data-mp="3c57fm9mchdyi">The 6 master volumes</span>} lead="150+ ready-to-teach lessons, sequenced from visual language through to professional practice. Open any volume to see what’s inside." data-id="element-219" data-mp="3c3wb27l2s26c" />

        <ol className="mt-8 space-y-2.5" data-id="element-221" data-mp="3l2zu5bk8shku">
          {volumes.map((volume, index) => {
          const accent = accentStyles[volume.accent];
          const isOpen = openIndex === index;
          return <li key={volume.code} className={`rounded-3xl border bg-shell transition-colors duration-150 ease-out ${isOpen ? accent.border : 'border-line'}`} data-id="element-222" data-mp="2sf3y892hytp4" data-mpi={index}>
                <h3 data-id="element-223" data-mp="2ee22ozr4js0a">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`volume-panel-${index}`} className="flex w-full items-center gap-4 rounded-3xl px-5 py-4 text-left focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-terracotta sm:px-6" data-id="element-224" data-mp="2edaewb3rqykk">
                    <span className={`inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-xl font-display text-sm ${accent.plate}`} aria-hidden="true" data-id="element-225" data-mp="1vfpq14107zzy">
                      {volume.code}
                    </span>
                    <span className="min-w-0 flex-1" data-id="element-226" data-mp="24gnufnfcu9j2">
                      <span className={`block font-display text-lg leading-snug ${accent.text}`} data-id="element-227" data-mp="24e2qmsvhxjio">
                        {volume.name}
                      </span>
                      <span className="mt-0.5 block font-sans text-[11px] uppercase tracking-[0.14em] text-stone" data-id="element-228" data-mp="3fu9gv0ttxx0w">
                        {volume.subtitle}
                      </span>
                    </span>
                    <ChevronDownIcon className={`h-4 w-4 shrink-0 text-stone transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-229" data-mp="1br81ww522brh" />
                  </button>
                </h3>

                <div id={`volume-panel-${index}`} className={`grid transition-[grid-template-rows,opacity] duration-200 ease-out ${isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'}`} data-id="element-230" data-mp="1kql9tkdj6sa3">
                  <div className="overflow-hidden" data-id="element-231" data-mp="szf5ssuowafj">
                    <div className="border-t border-line px-5 py-5 sm:px-6" data-id="element-232" data-mp="16tetrxk6z7ok">
                      <p className="font-sans text-[0.9rem] leading-relaxed text-stone" data-id="element-233" data-mp="121eqpw8trynr">
                        {volume.intro}
                      </p>
                      <ul className="mt-4 grid gap-x-6 gap-y-1.5 sm:grid-cols-2" data-id="element-234" data-mp="ea96l4vuqk7n">
                        {volume.focus.map(item => <li key={item} className="flex items-start gap-2 font-sans text-[0.85rem] leading-relaxed text-ink/85" data-id="element-235" data-mp="9beq49lcx7qp">
                            <CheckIcon className="mt-0.5 h-3 w-3 shrink-0 text-terracotta" strokeWidth={2.6} aria-hidden="true" data-id="element-236" data-mp="2pruo14wlywyl" />
                            {item}
                          </li>)}
                      </ul>
                      <p className="mt-5 border-t border-line pt-4 font-display text-base leading-snug text-ink" data-id="element-237" data-mp="2h02ceqvulhsf">
                        {volume.result}
                      </p>
                    </div>
                  </div>
                </div>
              </li>;
        })}
        </ol>
      </div>
    </section>;
}